import React from "react";
import {
    Theme,
    StandardProps,
    DialogTitle,
    DialogContent
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";
import Dialog from "@material-ui/core/Dialog";
import { FileManagerProps } from "js/react/scenes/components";
import MediaManagement from "js/react/scenes/components/MediaManagement/MediaManagement";
import { MemoryRouter } from "react-router-dom";

const styles = (theme: Theme) =>
    createStyles({
        root: {},
        paper: {
            width: 1050,
            maxWidth: 1050
        },
        title: {},
        content: {},
        btn: {},
        fullWidth: {},
        topWrapper: {
            display: "flex"
        },
        closeIconWrapper: {
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "flex-end"
        },
        closeIcon: {
            fontSize: "25px",
            marginRight: "20px",
            "&:hover": {
                cursor: "pointer"
            }
        }
    });

type MediaManagementDialogClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);

export interface MediaManagementDialogProps
    extends StandardProps<{}, MediaManagementDialogClassKey>,
        FileManagerProps {}

function Component(props: MediaManagementDialogProps) {
    const classes = useStyles(props);
    const { classes: cls, ...rest } = props;
    return (
        rest.open && (
            <MemoryRouter>
                <Dialog
                    classes={{
                        paper: classes.paper
                    }}
                    className={classes.root}
                    open={rest.open}
                    onClose={() => rest.onOpenChanged(false)}
                >
                    <div className={classes.topWrapper}>
                        <DialogTitle>File Manager</DialogTitle>
                        <div className={classes.closeIconWrapper}>
                            <FontAwesomeIcon
                                icon={["fal", "times"]}
                                className={classes.closeIcon}
                                onClick={() => rest.onOpenChanged(false)}
                            />
                        </div>
                    </div>

                    <DialogContent className={classes.content}>
                        <MediaManagement {...rest} />
                    </DialogContent>
                </Dialog>
            </MemoryRouter>
        )
    );
}

Component.defaultProps = {} as MediaManagementDialogProps;
Component.displayName = "MediaManagementDialog";
export const MediaManagementDialog = Component;
export default MediaManagementDialog;
